import { Component } from '@angular/core';
import { PropertySearchFacade } from '../../facades/property-search.facade';

/**
 * Contenedor de la pantalla de resultados de búsqueda.
 * UI-only: provee el {@link PropertySearchFacade} (scope de componente) y
 * cablea las vistas hijas a sus streams/intents. Sin lógica de negocio.
 */
@Component({
    selector: 'app-property-marketplace',
    templateUrl: './property-marketplace.component.html',
    styleUrls: ['./property-marketplace.component.scss'],
    providers: [PropertySearchFacade],
})
export class PropertyMarketplaceComponent {
    sidebarVisible = false;

    constructor(public facade: PropertySearchFacade) {}
}
